import OnboardingWizard from "../areas/onboarding/components/OnboardingWizard";
export default OnboardingWizard